module.exports = __webpack_public_path__ + "img/goblin.e509d3dd.png";